import React from "react";

export default function BackIcon(props) {
  const { selected } = props;

  return (
    <svg
      className={"svgIcon " + (selected ? " iconselected" : "")}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
    >
      <g strokeWidth="1">
        <path
          d="M21.276,8.526,18.75,6,8,16.75,18.75,27.5l2.526-2.526L13.07,16.75Z"
          transform="translate(0 3.25)"
        />
      </g>
    </svg>
  );
}
